import { Tabs, TabsContentProps } from '@chakra-ui/react';

import {
  PlanningBacklogFilterProvider,
  SelectedGoalsProvider,
} from 'features/planning';

import { PlanningBacklogChallenges } from './Challenges';

type TPlanningBacklogChallengesTab = TabsContentProps;

export const PlanningBacklogChallengesTab = (
  props: TPlanningBacklogChallengesTab
) => (
  <Tabs.Content
    m={0}
    p={0}
    height="100%"
    width="100%"
    overflowY="auto"
    overflowX="hidden"
    value={0}
    {...props}
  >
    <SelectedGoalsProvider>
      <PlanningBacklogFilterProvider>
        <PlanningBacklogChallenges />
      </PlanningBacklogFilterProvider>
    </SelectedGoalsProvider>
  </Tabs.Content>
);
